import { render } from "./SoporteAppTicketsPage.vue?vue&type=template&id=7198640f"
import script from "./SoporteAppTicketsPage.vue?vue&type=script&lang=js"
export * from "./SoporteAppTicketsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__